import { SettingsUserGroupsUserGroupDto, SettingsUserGroupsUserGroupFullDto } from '../interfaces';
import { generateId } from '../../../../utils';
import { Field, generateRandomFirstName, generateRandomString } from '../../../lib';

export const mockUserGroupFields: Field<SettingsUserGroupsUserGroupDto>[] = [
    {
        fieldName: 'id',
        value: generateId,
    },
    {
        fieldName: 'name',
        value: () => `User group for ${generateRandomFirstName()}`,
    },
    {
        fieldName: 'description',
        value: () => `Description of ${generateRandomFirstName()} User Group`,
    },
];

export const mockUserGroupFullFields: Field<SettingsUserGroupsUserGroupFullDto>[] = [
    {
        fieldName: 'id',
        value: generateId,
    },
    {
        fieldName: 'name',
        value: () => `User group for ${generateRandomFirstName()}`,
    },
    {
        fieldName: 'description',
        value: () => `Description of ${generateRandomFirstName()} User Group`,
    },
    {
        fieldName: 'clientGroupId',
        value: generateId,
    },
];
